import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function editMatch(
  league_pk,
  round_pk,
  match_pk,
  group1,
  group2,
  time,
  court
) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'PATCH',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/${match_pk}/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        teams: [group1, group2],
        court: court,
        start_time: time,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

